import React from 'react'
import Styled from 'styled-components'

import DeviceControls from 'components/DeviceControls'

const Canvas = Styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  ${props => props.isRightSidebarOpen && `
    width: calc(100% - 26rem);
  `}

  ${props => props.isLeftSidebarOpen && `
    width: calc(100% - 26rem);
    left: 26rem;
  `}
`

const ScrollView = Styled.div`
  position: relative;
  height: 100%;
  overflow: auto;
  padding: 0 4.5rem;
`

const ScrollViewPositioner = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 4.5rem 0;
`

const ScrollViewContent = Styled.div``

export default props => (
  <Canvas
    isRightSidebarOpen={props.isRightSidebarOpen}
    isLeftSidebarOpen={props.isLeftSidebarOpen}
    onClick={props.onCanvasClick}
  >
    <DeviceControls />

    <ScrollView>
      <ScrollViewPositioner id="editor-canvas">
        <ScrollViewContent>
          {props.children}
        </ScrollViewContent>
      </ScrollViewPositioner>
    </ScrollView>

  </Canvas>
)


// WEBPACK FOOTER //
// ./src/components/EditorCanvas/index.js